
<template>
  <div class="layout-header">
    <div class="layout-header__navs">
      <h3 class="u-logo">
       <img src="@/assets/imgs/logo.png" alt="" style="width: 30px;">
      </h3>
      <visited-views></visited-views>
      <!-- <top-menu></top-menu> -->
      <div class="navs_right">
        <div>
          <slot></slot>
        </div>
        <div class="extra-info">
          <!-- 个人中心 start -->
          <el-popover
            placement="bottom"
            trigger="click"
            width="320"
            :show-arrow="false"
            popper-style="padding: 0"
          >
            <template #reference>
              <div class="user-center-entrance">
                <div class="avatar">
                  {{ $store.state?.user?.userName }}
                </div>

                <el-icon class="tm-icon-xia">
                  <ArrowDown />
                </el-icon>
              </div>
              <!-- </div> -->
            </template>
            <div class="user-center">
              <div class="ava-box">
                <img src="@/assets/imgs/ava.png" alt="">
              </div>
              <div class="login-time">{{ $store.state?.user?.userName }}</div>
              <div class="login-time">最近登录时间：{{ $store.state?.user?.lastLoginTime }}</div>
              <ul>
                <li @click="showUserInfo" class="logout-li">个人配置</li>
                <li @click="handleLogout" class="logout-li">
                  <i class="iconfont tm-icon-tuichudenglu"></i>
                  注销
                </li>
              </ul>
            </div>
          </el-popover>
          <!-- 个人中心 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, inject, onMounted, onBeforeUnmount } from "vue"
import { ArrowDown, Download } from "@element-plus/icons-vue"
import { resetPassword } from "@/views/login/components/dialogs/index"
import { user_info_modal } from "./components/dialog"
import { editUser } from "@/views/users/components/dialogs";
import VisitedViews from "@/components/layout/VisitedViews"
import { logout } from "@/api/login"
import { useRouter } from "vue-router"
// import { setRouteParams, approveTypeEnum } from "@/views/message/const"

const $router = useRouter()
const $store = inject("$store")
const $fetch = inject("$fetch")
const data = reactive({
  userInfo: {
    trueName: "",
  },
  groups: [],
})
const state = reactive({
  env: process.env.VUE_APP_TITLE,
  showBackstageEntrance: false,
  currentGroupId: "",
  isAdmin: false,
  unreadMessageList: [],
})

const handleOpenBackstage = () => {}

const handleOpenHomePage = () => {}

const handleLogout = () => {
  logout()
    .then(() => {
      $router.push("/login")
      $store.dispatch("logout")
    })
    .catch(() => {})
}

const changePassword = () => {
  resetPassword({}).then(
    () => {
      $store.dispatch("logout")
      $router.push("/login")
    },
    () => {}
  )
}

const showUserInfo = () => {
  console.log($store)
  editUser({
    record: $store?.state?.user,
    config: {
      flag: true
    }
  }).then(
    () => {
    },
    () => {}
  );
}


</script>
<style lang="less" scoped>
.iconfont {
  color: #fff;
  font-size: 20px;
}
.set-icon {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.user-center-entrance {
  display: flex;
  align-items: center;
  cursor: pointer;
  .tm-icon-xia {
    font-size: 12px;
    margin-left: 9px;
    color: #fff;
  }
  .img_personal {
    margin-left: 25px;
    width: 20px;
    height: 20px;
  }
}

.user-center {
  > ul > li {
    height: 46px;
    line-height: 46px;
    position: relative;
    // padding-left: 44px;
    cursor: pointer;
    width: 50%;
    text-align: center;
    .tm-icon-xiala {
      color: #031d35;
      transform: rotate(270deg);
      font-size: 16px;
    }
    &:hover {
      background: #eff3f8;
      color: @navFontActiveColor;
      & > .iconfont {
        color: @navFontActiveColor;
      }
      .group-list {
        display: block;
      }
    }
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
  .ava-box {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    background: #eff3f8;
    margin-bottom: 10px;
    img {
      width: 40px;
    }
  }
  .login-time {
    padding: 5px 20px;
    text-align: center;
  }
  .logout-li {
    border-top: 1px solid #e5e5e5;
  }
  li > .iconfont:not([class*="-xiala"]) {
    color: #031d35;
    font-size: 16px;
    vertical-align: middle;
    position: absolute;
    left: 20px;
  }
}

.avatar {
  display: inline-block;
  // width: 34px;
  height: 34px;
  line-height: 32px;
  // background: #4786ff;
  // border: 2px solid #fff;
  border-radius: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.additional {
  color: #343f56;
  font-size: 12px;
  margin-top: 4px;
}

.mlf-notification-box {
  width: 400px;
  background: #e6f7ff;
  border-radius: 4px;
  border: 1px solid #91d5ff;
  padding: 18px 16px 18px 24px;
  cursor: pointer !important;
  .el-notification__group {
    flex: 1;
  }
  .el-notification__icon {
    color: #419ffd;
    font-size: 36px;
  }
  .el-notification__content {
    font-size: 14px;
  }
  .additional {
    color: #343f56;
    font-size: 12px;
    margin-top: 4px;
  }
  .el-notification__closeBtn {
    top: 16px;
    right: 18px;
    width: 14px;
    height: 14px;
  }
}
</style>
